export default `
<a ng-show="item.current_user_permissions.subscribe" title="{{getTitle(item.subscriptions.subscribed_by_current_user)}}" href="#" ng-click="toggleSubscription()" class="icon-bell subscribe-btn" ng-class="{active: item.subscriptions.subscribed_by_current_user}"></a>
`;
